import { RegionShared } from "@1games-ru/region-shared";
import { formatDate } from "date-fns";
import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";

export default function DeathScreenDescription({
  damages,
  deathTime,
  className,
}: typeof RegionShared.Types.Death.State & { className?: string }) {
  const { t } = useTranslation("deathScreen");
  return (
    <motion.div
      initial={{ opacity: 0, translateY: "100%" }}
      animate={{ opacity: 1, translateY: "none" }}
      transition={{ duration: 0.5, type: "spring" }}
      exit={{ opacity: 0, translateY: "100%" }}
      className={cn("flex flex-col items-center", className)}
    >
      <div className="text-white text-18 font-bold"> {t("deathScreen.damageReceived")}</div>

      <div className="flex flex-col items-center mt-3.5 gap-1.5">
        {damages.map((item) => (
          <div
            key={item.id}
            className="flex items-center gap-2.5 bg-dark-800 px-2.5 py-2 rounded-[0.5rem]"
          >
            <div className="text-15 font-bold text-white">
              {t("deathScreen.damageFrom")} <span className="text-[#FF4E4E]">{item.name}</span>{" "}
              <span>#{item.id}</span>
            </div>
            <div className="h-3 w-[1px] bg-white/20" />
            <div className="flex items-center gap-2">
              <div className="text-15 font-bold text-white">{item.hp}</div>{" "}
              <span className="text-11 uppercase text-black font-bold bg-[#FF4E4E] w-[1.5rem] h-[1.25rem] rounded-[0.4rem] flex items-center justify-center leading-[0.75%]">
                HP
              </span>
            </div>
            <div className="h-3 w-[1px] bg-white/20" />
            <div className="text-white text-15 font-medium">
              {t("deathScreen.typeDamage")}: <span className="font-bold">{item.type}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="text-white text-16 font-medium mt-3.5 px-4 py-3 bg-[#191919] rounded-[0.625rem]">
        {t("deathScreen.deathTime")} -{" "}
        <span className="font-bold text-[#FF4E4E]">
          {formatDate(new Date(deathTime), "HH:mm:ss")}
        </span>
      </div>
    </motion.div>
  );
}
